


































import { Component, Prop, Vue} from 'vue-property-decorator';
import Destination from '../Passenger/models/Destination';
import { Organization } from '../../models/Organization';
import CreateDestinationModal from '@/components/Organization/CreateDestinationModal.vue';
import User from '../../models/User';

@Component({
  components: {
    CreateDestinationModal,
  }
})
export default class DestinationsPage extends Vue{
  /*tslint:disable max-line-length*/
  search: string = '';

  openModal = false;

  pagination = {
    rowsPerPage: 10 // -1 for All,
  }
  
  get organizationId() {
    return this.$router.currentRoute.params.organizationId;
  }

  get destinations(): Destination[] {
    if (this.$store.state.organization.organizations) {
      return this.$store.state.organization.organizations
      .find(o => o.id === this.organizationId).destinations;
    }
    return [];
  }

  get headers() {
    const headers = [
      { text: this.$t('organization.destination', 'Destination'), value: 'alias', align: 'left', sortable: true },
      { text: this.$t('organization.addDestination.address', 'Address'), value: 'address', align: 'left', sortable: true },
      { text: this.$t('organization.addDestination.city', 'City'), value: 'city', align: 'left', sortable: true },
      { text: this.$t('organization.instances', 'Service providers'), value: 'movitInstanceName', align: 'left', sortable: true },
    ];
    if (this.isEspoo) {
      headers.push({ text: this.$t('organization.priceArea.priceArea', 'Price area'), value: 'priceArea', align: 'left', sortable: true });
    }
    return headers;
  }

  get isEspoo() {

    if (!this.organizationId) {
      return false;
    }
    
    const espooOrganizations: string[] = [
      '626a6858-8c19-4a69-b699-12e577ce012a'.toLowerCase(),
      '17dd2fb9-4253-4503-881d-f5cdb305ceaf'.toLowerCase()
    ];
    
    return espooOrganizations.includes(this.organizationId.toLowerCase());
  }

  get isAdminUser() {
    const organization = this.$store.state.organization.organizations.find(o => o.id === this.organizationId) as Organization;
    const user = this.$store.state.user.me as User;
    return organization.administratorIds.some(id => id === user.id);
  }
}
